import axios from 'axios';
import { BLOG_API_BASE_URL, http, requireResults, results } from './client';

const blog = axios.create({ baseURL: BLOG_API_BASE_URL, timeout: 30_000 });

/** Posts, newest first. */
export const listBlogPosts = () => blog.get('api/v1/blog').then((r) => results(r) || []);

export const getBlogPost = (id) =>
  blog.get(`api/v1/blog/${encodeURIComponent(id)}`).then((r) => results(r) ?? null);

/** Values the contact endpoint understands (it maps them to email labels). */
export const CONTACT_TOPICS = [
  { value: 'general', label: 'General question' },
  { value: 'bookingissue', label: 'Booking issue' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'bugreport', label: 'Report a bug' },
  { value: 'other', label: 'Other' },
];

export const sendContactMessage = ({ name, email, message, type }) =>
  http.post('api/v1/contactus', { name, email, message, type }).then(results);

/** Fails with HTTP 409 when the email is already subscribed. */
export const subscribeToNewsletter = (email) =>
  http.post('api/v1/subscribe', { email }).then(results);

export const unsubscribeFromNewsletter = (token) =>
  http.delete(`api/v1/subscribe/${encodeURIComponent(token)}`).then(requireResults);
